module.exports = __webpack_public_path__ + "static/media/6.bdb836e7.svg";